<template>
    <div>
        <div v-if="loading" class="loading-box">
            <div class="loader"></div>
        </div>
        <div class="my-main" :class="{'is-opacity': loading}">
            <div class="part-one">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in picList" :key="index">
                            <img :src="item" alt="" class="swiper-img">
                        </div>
                    </div>
                    <div class="pre-btn">
                        <img src="@/assets/icon_left.png" alt="" class="btn-img">
                    </div>
                    <div class="next-btn">
                        <img src="@/assets/icon_right.png" alt="" class="btn-img">
                    </div>
                </div>
            </div>
            <div class="part-two">
                <img src="@/assets/title_1.png" alt="" class="title-pic1">
                <div class="content-pic">
                    <template v-for="(item, index) in contentPic">
                        <div class="pic-line" v-if="index !== 0" :key="index"></div>
                        <img :src="item" alt="" class="pic-item" :key="item">
                    </template>
                </div>
                <img src="@/assets/title_2.png" alt="" class="title-pic2">
                <div class="list-box">
                    <div class="list-item" v-for="item in list" :key="item.id">
                        <div class="item-box" @click="openCustomer(item)">
                            <div class="left-box">
                                <div class="plant-box">
                                    <img :src="item.imageUrl" alt="" class="plant-img">
                                    <div class="plant-tag tag" :class="[colorShow[item.originCountry]]" v-if="item.grapeVariety">{{ item.grapeVariety }}</div>
                                </div>
                            </div>
                            <div class="right-box">
                                <div>
                                    <div class="name-price">
                                        <div class="name">{{ item.name }}</div>
                                        <div class="price">{{ item.brand }}<span class="big-num">{{ parseInt(item.price) }}</span><span class="dot-num" v-if="String(item.price).includes('.')">{{ getMiniNum(item.price) }}</span>
                                        </div>
                                    </div>
                                    <div class="area">
                                        <div class="area-item"><div>{{ item.originRegion }}</div></div>
                                        <!-- <div class="area-item"><div class="area-label">品种：</div><div>{{ item.grapeVariety }}</div></div> -->
                                    </div>
                                </div>
                                <div class="chart">
                                    <div class="chart-info">
                                        <div class="stock">库存：{{ item.stock || 0 }}</div>
                                        <div class="buy-btn" :class="{'gray': item.originCountry == 1}">购买</div>
                                    </div>
                                    <div class="chart-box">
                                        <myEcharts :info="item" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="copyright">Copyright © PREMIUMWILDGINSENG</div>
            </div>
        </div>
        <customer ref="customer" />
    </div>
</template>

<script>
    import Swiper from "swiper/swiper-bundle";
    import "swiper/swiper-bundle.css";
    import QualitySelection from "@/assets/content_1_QualitySelection.png"
    import QualityOriginalFactory from "@/assets/content_2_QualityOriginalFactory.png"
    import FactoryDirectSupply from "@/assets/content_3_FactoryDirectSupply.png"
    import NutrientAccumulation from "@/assets/content_4_NutrientAccumulation.png"
    import banner1 from "@/assets/swiper/banner1.png"
    import banner2 from "@/assets/swiper/banner2.png"
    import banner3 from "@/assets/swiper/banner3.png"
    import banner4 from "@/assets/swiper/banner4.jpg"
    import banner5 from "@/assets/swiper/banner5.jpg"
    import banner6 from "@/assets/swiper/banner6.jpg"
    import banner7 from "@/assets/swiper/banner7.jpg"
    import myEcharts from "./myEcharts.vue";
    import customer from "./customer.vue";
    import { queryProductList } from "@/api/index.js"
    export default {
        name: 'Home',
        components: { myEcharts, customer },
        data() {
            return {
                loading: true,
                picList: [banner1, banner2, banner3, banner4, banner5, banner6, banner7],
                swiper: undefined,
                contentPic: [QualitySelection, QualityOriginalFactory, FactoryDirectSupply, NutrientAccumulation],
                list: [],
                colorShow: {
                    1: "gray",
                    2: "orange",
                    3: "red"
                }
            }
        },
        mounted() {
            this.getList();
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.swiperInit);
        },
        methods: {
            openCustomer(e) {
                if (e.originCountry == 1) return
                this.$nextTick(() => {
                    this.$refs.customer.openService()
                })
            },
            getMiniNum(e) {
                let str = String(e)
                if (str.includes('.')) {
                    let index = str.indexOf('.')
                    return str.substring(index, str.length)
                }
                return ''
            },
            getList() {
                this.loading = true
                this.swiperInit()
                queryProductList({
                    status: 1,
                    orderByColumn: 'sortOrder',
                    isAsc: 'asc'
                }).then(res => {
                    this.list = res.rows && res.rows.length > 0 ? res.rows : []
                }).finally(() => {
                    this.loading = false
                })
            },
            swiperInit() {
                if (this.swiper) {
                    this.swiper.destroy(true, true);
                }
                this.$nextTick(() => {
                    this.swiper = new Swiper('.swiper-container', {
                        slidesPerView: 1,
                        spaceBetween: 0,
                        loop: true,
                        autoplay: { delay: 3000 },
                        navigation: {
                            nextEl: '.next-btn',
                            prevEl: '.pre-btn',
                        },
                        resizeObserver: true
                    });
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
.loading-box {
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    background: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
}
.loader {
  width: 50px;
  --b: 8px; 
  aspect-ratio: 1;
  border-radius: 50%;
  padding: 1px;
  background: conic-gradient(#0000 10%,#bba770) content-box;
  -webkit-mask: repeating-conic-gradient(#0000 0deg,#000 1deg 20deg,#0000 21deg 36deg),
    radial-gradient(farthest-side,#0000 calc(100% - var(--b) - 1px),#000 calc(100% - var(--b)));
  mask: repeating-conic-gradient(#0000 0deg,#000 1deg 20deg,#0000 21deg 36deg),
    radial-gradient(farthest-side,#0000 calc(100% - var(--b) - 1px),#000 calc(100% - var(--b)));
  -webkit-mask-composite: destination-in;
          mask-composite: intersect;
  animation:l4 1s infinite steps(10);
}
@keyframes l4 {to{transform: rotate(1turn)}}

.my-main {
    width: 100%;
    height: fit-content;
}

.is-opacity {
    opacity: 0;
}

img {
    user-select: none;
    display: block;
}

.part-one {
    width: 100%;
    padding-bottom: 50%;
    position: relative;
}

.swiper-container {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: #DCD8CD;
    overflow: hidden;
}

.swiper-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 0;
}

.swiper-slide {
    width: 100%;
    height: 100%;
    padding: 4.2% 8.4%;
    box-sizing: border-box;
}

.swiper-img {
    width: 100%;
    height: 100%;
    border-radius: 3.75%/7.5%;
    object-fit: cover;
}

.pre-btn,
.next-btn {
    position: absolute;
    z-index: 1;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.3);
    width: 2.08%;
    padding-bottom: 2.76%;
    cursor: pointer;
}

.pre-btn {
    left: 10.2%;
}

.next-btn {
    right: 10.2%;
}

.btn-img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 50%;
}

.part-two {
    width: 100%;
    height: fit-content;
    background-image: url("~@/assets/bg.png");
    background-size: 100% auto;
    background-color: #FFFFFF;
    padding: calc(5.2% * var(--pcRate)) 0;
    .copyright {
        width: 100%;
        text-align: center;
        color: #999999;
        font-size: calc(0.9375vw * var(--pcTextRate));
        margin-top: calc(5.46% * var(--pcTextRate));
    }
}

.title-pic1 {
    width: calc(11.82% * var(--pcTextRate));
    margin: 0 auto calc(4.16% * var(--pcRate));
}

.content-pic {
    width: 100%;
    margin-bottom: calc(5.2% * var(--pcRate));
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
}

.pic-item {
    width: calc(8.4% * var(--pcTextRate));
    // height: fit-content;
    display: block;
}

.pic-line {
    width: 1px;
    padding-bottom: calc(3.75% * var(--pcTextRate));
    background: #D2D2D2;
    margin: 0 calc(4.68% * var(--pcTextRate));
}

.title-pic2 {
    width: calc(14% * var(--pcTextRate));
    margin: 0 auto;
}

.list-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: calc(2.08% * var(--pcRate));
    .list-item {
        width: 48.69%;
        display: flex;
        margin-top: calc(4.28% * var(--pcRate));
        // width: 935px;
        &:nth-child(odd) {
            justify-content: flex-end;
        }
        &:nth-child(even) {
            justify-content: flex-start;
        }
        .item-box {
            width: 64%;
            display: flex;
            cursor: pointer;
            // width: 512px;
        }
        .left-box {
            width: 39.0625%;
            padding-bottom: 54.6875%;
            background: rgba(248,239,227,0.5);
            position: relative;
            margin-right: 3.125%;
            .plant-box {
                position: absolute;
                width: 95%;
                height: 96.4%;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                border: 1px solid #AD8852;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                justify-content: center;
                .plant-img {
                    max-width: 96%;
                    max-height: 96%;
                    object-fit: cover;
                    position: relative;
                    z-index: 0;
                }
                .plant-tag {
                    position: absolute;
                    right: 5.5%;
                    top: 4%;
                    z-index: 1;
                    font-size: calc(0.7291vw * var(--pcTextRate));
                    padding: 2px 4px;
                    box-sizing: border-box;
                    width: fit-content;
                    height: fit-content;
                    max-width: 89%;
                    word-break: break-all;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                }
            }
        }
        .right-box {
            // 296px
            flex: 1;
            max-width: 57.8125%;
            // height: fit-content;
            height: 100%;
            // font-size: 18px;
            font-size: calc(0.9375vw * var(--pcTextRate));
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .name-price {
                width: 100%;
                display: flex;
                justify-content: space-between;
                font-weight: 500;
                .name {
                    color: #272727;
                    word-break: break-all;
                    margin-right: calc(0.5vw * var(--pcRate));
                }
                .price {
                    color: #BA8537;
                    .big-num {
                        // font-size: 20px;
                        font-size: calc(1.04vw * var(--pcTextRate));
                    }
                    .dot-num {
                        // font-size: 16px;
                        font-size: calc(0.8333vw * var(--pcTextRate));
                    }
                }
            }
            .area {
                width: 100%;
                margin: 3% 0;
                font-weight: 400;
                // font-size: 14px;
                font-size: 77.78%;
                color: #999999;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                .area-item {
                    min-width: 48%;
                    width: fit-content;
                    display: flex;
                    word-break: break-all;
                    .area-label {
                        white-space: nowrap;
                    }
                }
            }
            .chart {
                width: 100%;
                padding-bottom: 70%;
                position: relative;
                .chart-box {
                    position: absolute;
                    left: 0;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    z-index: 0;
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
}

/* pc */
@media only screen and (max-width:1200px) {
    .item-box {
        width: 90% !important;
    }
}

/* h5 */
@media only screen and (max-width:800px) {
    .swiper-slide {
        padding: 0;
    }

    .swiper-img {
        border-radius: 0;
    }

    .pre-btn,
    .next-btn {
        width: 3.12%;
        padding-bottom: 4.14%;
    }

    .pre-btn {
        left: 4%;
    }

    .next-btn {
        right: 4%;
    }

    .pic-item {
        margin: 3% 0;
    }

    .pic-line:nth-of-type(2) {
        display: none;
    }

    .list-box {
        justify-content: center;
        .list-item {
            width: 90%;
            justify-content: center !important;
            .item-box {
                width: 100% !important;
            }
        }
    }
}
.chart-info {
    width: fit-content;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.stock {
    font-size: calc(0.7291vw * var(--pcTextRate));
    margin-right: calc(1vw * var(--pcTextRate));
    color: #BA8537;
}
.buy-btn {
    width: calc(3.541vw * var(--pcTextRate));
    height: calc(1.458vw * var(--pcTextRate));
    background: #BF8F4C;
    border-radius: calc(0.7291vw * var(--pcTextRate));
    text-align: center;
    line-height: calc(1.458vw * var(--pcTextRate));
    cursor: pointer;
    font-weight: 400;
    font-size: calc(0.7291vw * var(--pcTextRate));
    color: #FFFFFF;
}
.gray {
  background: #E5E5E5;
  color: #999999;
}
.orange {
  background: linear-gradient(90deg, #FA6436 0%, #F08864 100%);
  color: #FFFFFF;
}
.red {
  background: #FF3B30;
  color: #FFFFFF;
}
</style>